/**
 * Layout Registry
 * Central configuration for all layout modes
 */

import type { LayoutRegistry } from './types';

export const layoutRegistry: LayoutRegistry = {
  default: {
    mode: 'default',
    chrome: {
      header: true,
      footer: true,
      bottomNav: false,
      feedbackButton: true,
      trialBanner: true,
      animatedBackground: true,
      appPageHeader: true,
    },
    styles: {
      mainPadding: false,
      safeAreaInsets: false,
      backgroundVariant: 'default',
    },
  },
  app: {
    mode: 'app',
    chrome: {
      header: false,
      footer: false,
      bottomNav: true,
      feedbackButton: false,
      trialBanner: false,
      animatedBackground: false,
      appPageHeader: false,
    },
    styles: {
      mainPadding: true,
      safeAreaInsets: true,
      backgroundVariant: 'plain',
    },
    routes: {
      allowed: ['/add', '/projects', '/insights', '/account', '/plan', '/project-settings', '/project-config', '/architecture', '/architecture/import', '/login', '/signup', '/upgrade', '/admin'],
      redirectTo: '/add',
    },
  },
  kiosk: {
    mode: 'kiosk',
    chrome: {
      header: false,
      footer: false,
      bottomNav: false,
      feedbackButton: false,
      trialBanner: false,
      animatedBackground: true,
      appPageHeader: true,
    },
    styles: {
      mainPadding: false,
      safeAreaInsets: false,
      backgroundVariant: 'default',
    },
    routes: {
      allowed: ['/add', '/projects'],
      redirectTo: '/add',
    },
  },
  minimal: {
    mode: 'minimal',
    chrome: {
      header: true,
      footer: false,
      bottomNav: false,
      feedbackButton: false,
      trialBanner: false,
      animatedBackground: false,
      appPageHeader: true,
    },
    styles: {
      mainPadding: false,
      safeAreaInsets: false,
      backgroundVariant: 'minimal',
    },
  },
  admin: {
    mode: 'admin',
    chrome: {
      header: true,
      footer: false,
      bottomNav: false,
      feedbackButton: false,
      trialBanner: false,
      animatedBackground: false,
      appPageHeader: true,
    },
    styles: {
      mainPadding: false,
      safeAreaInsets: false,
      backgroundVariant: 'minimal',
    },
  },
  embedded: {
    mode: 'embedded',
    chrome: {
      header: false,
      footer: false,
      bottomNav: false,
      feedbackButton: false,
      trialBanner: false,
      animatedBackground: false,
      appPageHeader: false,
    },
    styles: {
      mainPadding: false,
      safeAreaInsets: false,
      backgroundVariant: 'plain',
    },
  },
};
